import { useEffect, useState } from 'react';
import { mailDomain } from '../lib/org';

const box = 'mt-1 w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm';
const copy = (t) => { try { navigator.clipboard.writeText(t); } catch (_) { /* sin portapapeles */ } };

// Asistente para enviar los mails desde el dominio propio de la organización (p. ej. no-responder@sushiko.com).
export default function MailDomain({ showToast }) {
  const [st, setSt] = useState(null);
  const [domain, setDomain] = useState('');
  const [local, setLocal] = useState('no-responder');
  const [busy, setBusy] = useState(false);

  const run = async (action, extra, ok) => {
    setBusy(true);
    try { const r = await mailDomain(action, extra); setSt(r); if (ok) showToast?.(typeof ok === 'function' ? ok(r) : ok); }
    catch (e) { showToast?.(e.message || 'No se pudo completar', 'error'); }
    setBusy(false);
  };
  useEffect(() => { mailDomain('status').then((r) => { setSt(r); if (r.domain) { setDomain(r.domain); setLocal(r.local || 'no-responder'); } }).catch(() => setSt({ included: false, error: true })); }, []);

  if (!st) return null;
  if (st.error) return null;
  const from = st.domain ? `${st.local}@${st.domain}` : null;

  return (
    <div className="rounded-2xl border border-gray-100 p-4 space-y-3">
      <div>
        <p className="text-sm font-bold text-gray-800">Mails desde tu propio dominio</p>
        <p className="text-xs text-gray-400 mt-0.5">Por defecto los mails salen desde la dirección de la plataforma con el nombre de tu organización. Si tenés un dominio propio, pueden salir desde ahí.</p>
      </div>

      {!st.included ? (
        <p className="text-xs text-amber-700 bg-amber-50 rounded-xl px-3 py-2">Esta función viene con los planes Business y Total. Escribinos si querés activarla.</p>
      ) : st.status === 'verified' ? (
        <div className="space-y-2">
          <p className="text-sm text-teal-700 bg-teal-50 rounded-xl px-3 py-2">✓ Verificado. Tus mails salen desde <b>{from}</b></p>
          <button disabled={busy} onClick={() => { if (window.confirm('¿Volver a usar el remitente de la plataforma?')) run('remove', {}, 'Dominio quitado'); }} className="text-xs font-bold text-red-500">Quitar dominio propio</button>
        </div>
      ) : st.status === 'pending' ? (
        <div className="space-y-3">
          <p className="text-xs text-gray-600">Para usar <b>{from}</b>, cargá estos 2 registros en el panel de tu dominio (donde lo compraste o donde administrás el DNS: GoDaddy, Donweb, Cloudflare, Nic.ar, etc.). Después tocá «Verificar». Puede demorar desde unos minutos hasta unas horas.</p>
          {(st.dns || []).map((r) => (
            <div key={r.name} className={`rounded-xl border p-3 text-xs space-y-1 ${r.ok ? 'border-teal-200 bg-teal-50' : 'border-gray-200'}`}>
              <p className="font-bold text-gray-700">{r.what} {r.ok ? <span className="text-teal-600">· ✓ listo</span> : <span className="text-amber-600">· falta cargar</span>}</p>
              <p className="text-gray-500">Tipo: <b>{r.type}</b></p>
              <p className="text-gray-500 break-all">Nombre / Host: <b>{r.name}</b> <button onClick={() => copy(r.name)} className="text-sky-700 font-bold ml-1">Copiar</button></p>
              <p className="text-gray-500 break-all">Valor / Apunta a: <b>{r.value}</b> <button onClick={() => copy(r.value)} className="text-sky-700 font-bold ml-1">Copiar</button></p>
            </div>
          ))}
          <p className="text-[11px] text-gray-400">Si tu proveedor agrega solo el dominio al final del nombre, escribí únicamente la parte anterior a «.{st.domain}».</p>
          <button disabled={busy} onClick={() => run('verify', {}, (r) => r.status === 'verified' ? '✓ Dominio verificado' : 'Todavía no se detectan los registros')} className="w-full py-2.5 rounded-xl text-sm font-bold text-white bg-sky-700 disabled:opacity-50">{busy ? 'Verificando…' : 'Verificar'}</button>
          <button disabled={busy} onClick={() => run('remove', {}, 'Cancelado')} className="text-xs font-bold text-gray-400">Cancelar</button>
        </div>
      ) : (
        <div className="space-y-2">
          <label className="block text-xs font-semibold text-gray-500">Tu dominio
            <input value={domain} onChange={(e) => setDomain(e.target.value)} placeholder="sushiko.com" className={box} />
          </label>
          <label className="block text-xs font-semibold text-gray-500">Dirección desde la que se envía
            <div className="flex items-center gap-1"><input value={local} onChange={(e) => setLocal(e.target.value)} className={box} /><span className="text-sm text-gray-400 mt-1 whitespace-nowrap">@{domain || 'tudominio.com'}</span></div>
          </label>
          <button disabled={busy || domain.trim().length < 4} onClick={() => run('start', { domain, local }, 'Dominio registrado: falta cargar los registros')} className="w-full py-2.5 rounded-xl text-sm font-bold text-white bg-sky-700 disabled:opacity-50">{busy ? 'Preparando…' : 'Continuar'}</button>
        </div>
      )}
    </div>
  );
}
